module.exports = __webpack_public_path__ + "static/Costumize-Welcome-Message-5-e1403554704119-2d9a12d43d2f2ff391e549f4afa3fdb7.jpg";